import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { Router } from '@angular/router';
import { Evento } from '../models/evento';

@Component({
  selector: 'app-calendariojump',
  templateUrl: './calendariojump.component.html',
  styleUrls: ['./calendariojump.component.css']
})
export class CalendariojumpComponent implements OnInit {
  eventi: Evento[]=[];
  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit() {
    this.commonService.eventipercalendario=undefined;
    this.commonService.getAllEventi().subscribe(res => {
      this.eventi = res;
      this.eventi.forEach(element => {
        if (this.commonService.eventipercalendario===undefined){
          this.commonService.eventipercalendario=[{id: element.Id.toString(), title: element.Titolo, start: element.Datainizio+'T'+element.Timeinizio, end: element.Datafine+'T'+element.Timefine}];
        }else{
          this.commonService.eventipercalendario.push({id: element.Id.toString(), title: element.Titolo, start: element.Datainizio+'T'+element.Timeinizio, end: element.Datafine+'T'+element.Timefine});
        }
      });
      this.router.navigate(['calendario']);
    });
  }
  ngDoCheck(){
  //  alert("ngDoCheck");
  }
  ngAfterContentInit(){
  //  alert("ngAfterContentInit");
  }

  ngAfterContentChecked(){
//    alert("ngAfterContentChecked");
  }
  ngAfterViewInit(){
//    alert("ngAfterViewInit");
  }
  ngAfterViewChecked(){
//    alert("ngAfterViewChecked");
  }

  ngOnDestroy(){
//    alert("ngOnDestroy");
  }
}
